import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/*
 * Conditional hydration: when react-snap has prerendered HTML into #root
 * at build time, we hydrate it to reuse the existing DOM. For dev / any
 * route react-snap didn't prerender, we fall back to createRoot().render().
 */
const container = document.getElementById('root');

/* react-snap пререндерит в #root ТОЛЬКО главную ("/"). Поэтому гидратация
   допустима исключительно на этом пути. На любом другом маршруте
   (например, /site/:slug — публичное приглашение) в #root «запечена»
   разметка лендинга; hydrateRoot поверх неё даёт рассинхрон — остаются
   чужие узлы и стили, из-за чего на проде «едет» сетка и шрифты. В этом
   случае очищаем #root и делаем обычный createRoot. */
/* На поддомене сайта-приглашения (<slug>.amorika.love) pathname тоже '/',
   но это НЕ лендинг — гидратировать пререндер лендинга нельзя (node-ogSite
   к тому же отдаёт пустой #root для таких хостов). Поэтому поддомен
   приравниваем к site-маршруту → чистый createRoot. */
const host = window.location.hostname;
const sub = host.endsWith('.amorika.love')
  ? host.slice(0, -'.amorika.love'.length)
  : host.endsWith('.localhost') ? host.slice(0, -'.localhost'.length) : '';
const onSiteSubdomain = !!sub && !sub.includes('.') &&
  !['www', 'api', 'admin', 'mail', 'pro', 'm', 'static', 'cdn'].includes(sub.toLowerCase());

const isPrerenderedRoute = window.location.pathname === '/' && !onSiteSubdomain;

if (container.hasChildNodes() && isPrerenderedRoute) {
  ReactDOM.hydrateRoot(container, <React.StrictMode><App /></React.StrictMode>);
} else {
  container.innerHTML = '';
  ReactDOM.createRoot(container).render(<React.StrictMode><App /></React.StrictMode>);
}
